module.exports = __webpack_public_path__ + "img/cny.61c01da3.svg";